module.exports = "/images/vendor/photoswipe/dist/default-skin/default-skin.svg?b257fa9c5ac8c515ac4d77a667ce2943";


//////////////////
// WEBPACK FOOTER
// ./node_modules/photoswipe/dist/default-skin/default-skin.svg
// module id = 3S8j
// module chunks = 1 2 4 5 15 17 18 19